module.exports = __webpack_public_path__ + "static/google-play-badge-9a368c61b5b441e1fa237ad4945b1717.png";